<style>
    @media screen and (max-width: 767px) {
        .breadcrumb .breadcrumb-item {
            display: contents;
        }
        .breadcrumb .breadcrumb-item:last-child {
            display: contents;
        }
    }
</style>
<!-- breadcrumb -->
<ul class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last; let i = index" class="breadcrumb-item">
        <a class="breadcrum-item" routerLink="{{breadcrumb.url}}" *ngIf="!last && i == 0">
            {{ breadcrumb.label | translate}}
        </a>
        <a class="breadcrum-item" routerLink="{{breadcrumb.url}}" *ngIf="!last && i != 1 && i != 0">
            {{ breadcrumb.label | translate}}
        </a>
        <a class="breadcrum-item" style="color: #858796; cursor: default;" *ngIf="!last && i == 1">
            {{ breadcrumb.label | translate}}
        </a>
        <a class="breadcrum-item breadcrumb-highlight" style="cursor: default;" *ngIf="last && breadcrumb.highlight">
            {{ breadcrumb.label | translate}}
        </a>
        <a class="breadcrum-item" style="cursor: default;" *ngIf="last && !breadcrumb.highlight">
            {{ breadcrumb.label | translate}}
        </a>
    </li>
</ul>
